import { useState } from 'react';
import mail from '../../assets/icons/mail_art.svg';
import style from './contact.module.css';

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!name.length || !email.length || !message.length) {
      alert('Please fill out all fields');
      return;
    }

    if (
      !String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      alert('Please enter a valid email');
      return;
    }

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form-name': 'contact',
        name,
        email,
        message,
      }).toString(),
    })
      .then((res) => {
        console.log(res);
        alert('Success!');
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
  };

  return (
    <div className={style.contact} id="contact">
      <div>
        <div>
          <h2>Contact Me</h2>
          <img src={mail} alt="Contact art" />
        </div>
        <form name="contact" data-netlify="true" onSubmit={handleSubmit}>
          <label>
            Name:
            <input
              type="text"
              autoComplete="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Message:
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>
          <button type="submit">Send</button>
        </form>
      </div>
      <a href="#hero">Back to Top ↑</a>
    </div>
  );
}
